import React, { useState } from "react";
import {
  CompanyProfileWidget,
  CompanyProfileWidgetProps,
  ThemeType,
  WidgetError,
  WidgetMessage,
  WidgetHeightMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";

const CompanyProfile: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const symbol = queryParams.get("symbol") || "";
  const token = queryParams.get("token") || "";
  const theme = queryParams.get("theme") || ThemeType.Direct;

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.CompanyProfile,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(error),
        "*",
      );
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: CompanyProfileWidgetProps = {
    symbol: symbol,
    token: token,
    theme: theme as ThemeType,
    onError: handleError,
    onNoData: handleNoData,
    onLoadingChange: handleLoadingChange,
    onHeightChange: handleHeightChange,
  };

  return (
    <Spin
      wrapperClassName="widget-spin"
      spinning={isLoading}
      indicator={<CircularProgress theme={theme as ThemeType} />}
    >
      <CompanyProfileWidget {...props} />
    </Spin>
  );
};

export default CompanyProfile;
